export const NO_PERMISSIONS_FOR_ROUTE = (path: string) =>
    `No match found for path ${path} in the config.json permissionsByKPI. 
    Please add an array of permission groups for the key ${path}.`
export const errors = {
    error_message: 'Looks like something went wrong.',
}
